import { ContextBackdropProgress } from "contexts/ContextBackdropProgress";
import { useContext } from "react";

const useBackdropProgress = () => useContext(ContextBackdropProgress);

export default useBackdropProgress;
